import React from 'react'

const Directions = (props) => (
    <div id="author-directions-container" className="flex-column-centered clickable max-size" onClick={props.openAttachments}>
        <div id="wi-directions-label">
            Set a default attachment to view in this window
        </div>
    </div>)
export default Directions